import React from "react";
import { Col, Container, Row } from "shared-portal-component";

import Header from "@/components/molecules/Header/Header";
import '@/layout/LoggedInLayout/LoggedInLayout.scss';

const DEFAULT_MESSAGE_COUNT = 0;

interface LoggedInLayoutProps {
  children: React.ReactNode;
  logoSrc?: string;
  customerName?: string;
  customerInitials?: string;
  messageCount?: number;
}

const LoggedInLayout: React.FC<LoggedInLayoutProps> = ({
  children,
  logoSrc = "/portalSixLogo.svg",
  customerName = "Acme Law, LLC",
  customerInitials = "CK",
  messageCount = DEFAULT_MESSAGE_COUNT,
}) => (
  <Container fluid className="logged-in-layout">
    <Row spacing="none">
      <Col size={12}>
        <Header
          logo={{
            imageSrc: logoSrc,
            alt: "PortalSIX Logo"
          }}
          customerName={customerName}
          messageCount={messageCount}
          customerInitials={customerInitials}
        />
      </Col>
    </Row>
    <Row spacing="none" className="logged-in-main-row">
      <Col size={12} className="logged-in-main">
        {children}
      </Col>
    </Row>
  </Container>
);

export default LoggedInLayout;
